import { XaAjax } from '@/utilities/XaAjax.js';

let medalliaInfo = window.medalliaInfo || [];

async function medalliaOnWindowLoad() {
	const ajax = new XaAjax('/apps/xa/ws', true);
	const loggedIn = await ajax.get('/auth/status');

	if (loggedIn !== 'You are not logged in') {
		try {
			medalliaInfo = await ajax.get('/shell/data/medallia');

			if (medalliaInfo.enabled) {
				// Medallia reuses much of the information stored in the walkMeAnalytics object.
				// However, there are a couple additional pieces of information it needs. We're exposing that information here.
				window.medalliaInfo = medalliaInfo;

				const uv = document.createElement('script');
				uv.type = 'text/javascript';
				uv.async = true;
				uv.src = 'https://nebula-cdn.kampyle.com/us/wu/909844/onsite/embed.js';
				const s = document.getElementsByTagName('script')[0];
				s.parentNode.insertBefore(uv, s);
			}
		}
		catch (error) {
			console.error('Medallia Error: ', error);
		}
		finally {
			window.top.medalliaLoaded = true;
		}
	}
}

if (!window.top.medalliaLoaded) {
	if (window.top.document.readyState === 'complete') {
		medalliaOnWindowLoad();
	}
	else if (window.top.addEventListener) {
		window.top.addEventListener('load', medalliaOnWindowLoad);
	}
}
